import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { ReactNodeViewRenderer } from "@tiptap/react";
// lowlight v3 exposes a factory; v2's `lowlight.registerLanguage` is gone.
import { createLowlight } from "lowlight";
import bash from "highlight.js/lib/languages/bash";
import csharp from "highlight.js/lib/languages/csharp";
import css from "highlight.js/lib/languages/css";
import go from "highlight.js/lib/languages/go";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import markdown from "highlight.js/lib/languages/markdown";
import php from "highlight.js/lib/languages/php";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import ruby from "highlight.js/lib/languages/ruby";
import rust from "highlight.js/lib/languages/rust";
import sql from "highlight.js/lib/languages/sql";
import typescript from "highlight.js/lib/languages/typescript";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import { CodeBlockNodeView } from "./code-block-node-view";

export { CODE_LANGUAGES } from "./code-languages";

const lowlight = createLowlight();

lowlight.register("plaintext", plaintext);
lowlight.register("typescript", typescript);
lowlight.register("javascript", javascript);
// TSX has no grammar of its own in highlight.js; the TypeScript one covers it.
lowlight.register("tsx", typescript);
lowlight.register("json", json);
lowlight.register("bash", bash);
lowlight.register("python", python);
lowlight.register("go", go);
lowlight.register("java", java);
lowlight.register("csharp", csharp);
lowlight.register("sql", sql);
lowlight.register("css", css);
lowlight.register("xml", xml);
lowlight.register("yaml", yaml);
lowlight.register("markdown", markdown);
lowlight.register("php", php);
lowlight.register("ruby", ruby);
lowlight.register("rust", rust);

export const CodeBlockWithLanguage = CodeBlockLowlight.extend({
  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockNodeView);
  },
}).configure({ lowlight, defaultLanguage: "plaintext" });
